import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, of, timer, lastValueFrom } from 'rxjs';
import { User } from '../../../shared/models/user';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { map } from 'rxjs/operators';
import { UserManager, UserManagerSettings } from 'oidc-client-ts';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CookieService } from 'ngx-cookie-service';
import { LoaderService } from '../loader/loader.service';
import { SplunkService } from '../splunk/splunk.service';
import { OidcClientService } from '../oidc-client-ts/oidc-client.service';
import { Common } from '../../common/common';
import { IMUserRole } from 'src/app/shared/models/im-user-role.model';
import { APIEndPoints } from 'src/app/shared/APIEndPoints';
import { AccessTokenResult } from 'src/app/shared/models/access_token_result';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  myAccountSignoutSubject = new BehaviorSubject<boolean>(false);
  myAccountSignOutSuccess = this.myAccountSignoutSubject.asObservable();

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  myAccountWindow: Window;
  set isUserActiveInPC(value: boolean) {
    localStorage.setItem(this.configService.isUserActiveInPC, value ? '1' : '0');
  }
  get isUserActiveInPC(): boolean {
    return localStorage.getItem(this.configService.isUserActiveInPC) === '1';
  }

  isConfigServiceLoaded: boolean;
  configServiceSubscription: Subscription;
  securityApiUrl: string;
  private manager: UserManager;
  private user: User = null;
  logOutOldURL = 'Default.aspx?action=logout';
  jwthelper = new JwtHelperService();
  refreshSubscription: any;
  tokenTimer: any;
  challenge: { code_verifier: string; code_challenge: string; };
  encryptedString: any;
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private cookieService: CookieService,
    private loaderService: LoaderService,
    private splunkService: SplunkService,
    private oidcClientService: OidcClientService,

    public datepipe: DatePipe
  ) {
    this.configServiceSubscription = this.configService.isConfigServiceLoaded.subscribe(isloaded => {
      this.isConfigServiceLoaded = isloaded;

      if (this.isConfigServiceLoaded) {
        this.setCurrentUserSubscription();
        this.securityApiUrl = this.configService.apiUri;
      }
    });
  }

  setCurrentUserSubscription() {
    this.currentUserSubject = localStorage.getItem(this.configService.currentUser_env_config) ?
      new BehaviorSubject<User>(JSON.parse(atob(localStorage.getItem(this.configService.currentUser_env_config)))) :
      new BehaviorSubject<User>(null);
    this.currentUser = this.currentUserSubject.asObservable();
  }
  public get getUserProfile() {
    return this.currentUserSubject.value?.profile;
  }
  public clearIsUserActiveInPC(): void {
    localStorage.removeItem(this.configService.isUserActiveInPC);
  }
  public getUserId() {
    return this.currentUserSubject.value?.profile?.UserId;
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public get isAuthenticated(): Boolean {
    return this.currentUserSubject.value != null;
  }

  public get currentUserName(): string {
    return `${this.currentUserSubject.value?.profile?.LastName}, ${this.currentUserSubject?.value?.profile?.FirstName}`;
  }
  public get currentUserId(): string {
    return this.currentUserSubject.value?.profile?.UserName;
  }

  getMyAccountToken(body: IMUserRole): Observable<AccessTokenResult> {
    return this.http.post<AccessTokenResult>(`${this.configService.apiUri}${APIEndPoints.getMyAccountToken}`, body);
  }
  startAuthentication() {
    this.loaderService.show();
    this.oidcClientService.login();
  }

  // redirectToMyAccount(accessToken) {
  //   window.open(`${this.configService.hsid_impersonation_url}?pfidpadapterid=${this.configService.hsid_pfidpadapterid}&client_id=${this.configService.hsid_client_id}&response_type=code&redirect_uri=${this.configService.hsid_redirect_uri}&scope=${this.configService.hsid_scope}&state=home&portal=${this.configService.hsid_portal}&DLWSTICKET=${accessToken}`);
  // }

  // goToMyAccountLite(insuredId, ClientId, firstName, lastName, dateOfBirth, secondaryEmail, srId) {
  //   const body: IMUserRole = {
  //     ClientId: ClientId,
  //     InsuredID: insuredId,
  //     UserId: Number(this.getUserId()),
  //     UserName: this.currentUserId,
  //     FirstName: firstName,
  //     LastName: lastName,
  //     DOB: this.datepipe.transform(dateOfBirth, "MM/dd/yyyy", this.configService.timeZone),
  //     Id: srId,
  //     Email: secondaryEmail
  //   };
  //   this.getMyAccountToken(body).subscribe({
  //     next: (res: AccessTokenResult) => {
  //       if (res?.AuthSession && res?.AuthSession?.value) {
  //         this.redirectToMyAccount(res?.AuthSession?.value);
  //         // this.currentUserSubject.value.myAccountAccessToken = res?.access_token;
  //         // let currentDate = new Date();
  //         // currentDate.setSeconds(Number(res.expires_in));
  //         // this.currentUserSubject.value.myAccountAccessToken_expires_in = currentDate.valueOf();
  //         // this.setUserStorage(this.currentUserSubject.value);
  //       }
  //       else
  //         console.log('error');
  //     },
  //     error: (error) => console.error(`error : ${error}`),
  //     complete: () => {
  //     }
  //   });
  // }

  redirectToMyAccount() {
    this.scheduleTokenRenewal(true);
  }
  openMyAccountPage(): void {
    let _user = this.getOIDCUser();
    const accessToken = _user.access_token;
    window.open(`${this.configService.myaccount_RedirectUri}pcToken?accessToken=${accessToken}&role=${this.encryptedString}`);
  }
  async goToMyAccountLite(insuredId, ClientId) {
    this.encryptedString = await this.getEncryptedString(insuredId, ClientId);
    this.redirectToMyAccount();
  }

  // async generateEncryptedString(insuredId, ClientId) {
  //   var response = await this.getEncryptedString(insuredId, ClientId);
  //   return response;
  // }

  public async getEncryptedString(insuredId, ClientId) {
    var userId = this.getUserId();
    var url = this.configService.apiUri + APIEndPoints.generateMyAccountUri + '?userId=' + userId + '&insuredId=' + insuredId + '&clientId=' + ClientId;
    return await lastValueFrom(this.http.get(url, { responseType: 'text' }));
  }
  clearUserStorage() {
    this.currentUserSubject.next(undefined);
    localStorage.removeItem(this.configService.currentUser_env_config);
    localStorage.removeItem(this.configService.currentClientKey);
    localStorage.removeItem(this.configService.encryptedRolesKey);
  }
  logout() {
  }

  // OIDC Client methods
  isLoggedIn(): boolean {
    const user = this.getOIDCUser();
    return user != null && user.access_token != null && !this.isAccessTokenExpired();
  }
  isAccessTokenExpired() {
    const user = this.getOIDCUser();
    return (Common.convertTimeStampToseconds(user.expires_at) <= 0);

  }

  unscheduleTokenRenewal() {
    window.clearInterval(this.tokenTimer);
    this.tokenTimer = null;
  }

  scheduleTokenRenewal(isImpersonation = false) {
    const user = this.getOIDCUser();
    const seconds = isImpersonation ? 1200 : 150;
    if (user.access_token) {
      // in seconds
      let tokenInSeconds = Common.convertTimeStampToseconds(user.expires_at);
      if (this.tokenTimer) {
        this.unscheduleTokenRenewal();
      }
      if (tokenInSeconds < seconds) {
        this.unscheduleTokenRenewal();
        this.renewToken(this, isImpersonation);
        return;
      }
      if (isImpersonation)
        this.openMyAccountPage();
      if (!this.tokenTimer) {

        this.tokenTimer = window.setInterval(() => {
          if (tokenInSeconds > 0) {

            this.unscheduleTokenRenewal();
            this.renewToken(this, isImpersonation);

          }
        }, (tokenInSeconds - 120) * 1000);
      }
    } else {
      this.unscheduleTokenRenewal();
      this.startAuthentication();
    }
    // this.splunkService.log('info', {
    //   request: user,
    //   response: { result: user.access_token }
    // }, this.getUserProfile.UserId);
  }

  renewToken(that, isImpersonation = false) {
    this.oidcClientService.renewToken()
      .then(user => {
        if (isImpersonation)
          this.openMyAccountPage();
        this.scheduleTokenRenewal();
        // renew encrypted roles token from security api when renewing oidc token
        this.renewRoleToken();
      })
      .catch(err => console.log(err));

    
    
  }

  login(username: string, password: string) {
    return this.http.post<any>(this.configService.apiUri + `/api/Account/Login`, { username, password })
      .pipe(map(user => {
        // login successful if there's a jwt token in the response
        if (user && user.UserName) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem(this.configService.currentUser_env_config, btoa(JSON.stringify(user)));
          this.currentUserSubject.next(user);

          // this.splunkService.log('info', {
          //   request: user,
          //   response: { result: user }
          // }, this.getUserProfile.UserId);
          return user;
        }
      }));
  }

  // updatePermission(permissions: any) {
  //   const user = this.currentUserSubject.value;
  //   [permissions['WaiverManagement']].forEach(e => {
  //     e.AllowedClientIds = user.profile.Permissions['WaiverManagement'].AllowedClientIds;
  //   });
  //   user.profile.Permissions['WaiverManagement'] = permissions['WaiverManagement'];
  //   this.currentUserSubject.next(user);
  //   localStorage.setItem('currentUser', btoa(JSON.stringify(user)));
  // }
  getOIDCUser() {
    if (this.isConfigServiceLoaded) {
      const user = JSON.parse(localStorage.getItem(`${this.configService.oidcUser}${this.configService.idp_AuthorizationUrl}:${this.configService.idp_ClientId}`));
      return user;
    }
  }

  getLocalStorageItem() {
    if (this.isConfigServiceLoaded) {
      if (localStorage.getItem(this.configService.currentUser_env_config)) {

        const user: User = JSON.parse(atob(localStorage.getItem(this.configService.currentUser_env_config)));
        if (user) {
          return user;
        }
      } else {
        return null;
      }
    }
  }
  setUserStorage(user) {
    if (user && user.profile.UserName) {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      if (localStorage.getItem(this.configService.currentUser_env_config)) {
        localStorage.removeItem(this.configService.currentUser_env_config);
      }
      localStorage.setItem(this.configService.currentUser_env_config, btoa(JSON.stringify(user)));
      this.currentUserSubject.next(user);
    }
  }

  getDecodedAccessToken(token: string): any {
    return this.jwthelper.decodeToken(token);
  }

  getMyAccountTokenExpiration(token) {
    const tokenInfo = this.getDecodedAccessToken(token); // decode token
    this.getTokenExpirationDate(tokenInfo.expires_in);
  }

  getTokenExpirationDate(token) {
    return this.jwthelper.getTokenExpirationDate(token);
  }

  isMyAccountTokenExpired() {
    if (this.cookieService.get(this.configService.myaccount_cookie_key)) {
      let cookieToken = JSON.parse(decodeURIComponent(this.cookieService.get(this.configService.myaccount_cookie_key)));
      let expTime = new Date(cookieToken?.object.creationTime * 1000)
      expTime.setMinutes(expTime.getMinutes() + 20); // add 20 minutes to creationTime
      let diff = (expTime.getTime() - new Date().getTime()) / 1000;
      return (diff <= 0);
    } else {
      return true;
    }
  }

  setInsuredDisplayMsgCookie(chkDisplayMsg, username) {
    this.cookieService.set(username + 'Insured_Display_Message', chkDisplayMsg);
  }

  getInsuredDisplayMsgCookie(username) {
    return this.cookieService.get(username + 'Insured_Display_Message');
  }

  deleteCookieonLogout() {
    if (this.cookieService.check(this.configService.myaccount_cookie_key)) {
      this.cookieService.delete(this.configService.myaccount_cookie_key, '/', '.uhcsr.com', false, 'None');
    }
  }
  getUserDetails(username: string) {
    return this.http.get<any>(`${this.securityApiUrl + APIEndPoints.getUserDetails}${username}`);
  }
  renewRoleToken() {
    this.getUserDetails(this.currentUserValue.uuid)
      .subscribe({
        next: (response) => {
          // const roles = response['Roles'];
          const EncRoles = response['EncRoles'];
          localStorage.setItem('encryptedRoles', EncRoles);
        }
      });
  }
}